var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduitIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.679,
    height: 33.052,
    viewBox: "0 0 9.679 33.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "porduits",
    transform: "translate(-1399.092 -206.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_221",
    "data-name": "Groupe 221",
    transform: "translate(1399.842 207.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_220",
    "data-name": "Groupe 220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1123",
    "data-name": "Trac\\xE9 1123",
    d: "M1407.344,209.53v8.014h-4.907v-6c0-.892-.056-1.61.67-2.123l3.227-2.281c.856-.6,1.011.949,1.011,2.389Z",
    transform: "translate(-1400.8 -207.007)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1124",
    "data-name": "Trac\\xE9 1124",
    d: "M1400.954,223.72h6.777V229.9h-6.777V223.72Z",
    transform: "translate(-1400.253 -213.183)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1125",
    "data-name": "Trac\\xE9 1125",
    d: "M1408.021,250.051h-8.179V238.133h8.179v11.917Z",
    transform: "translate(-1399.842 -218.509)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1126",
    "data-name": "Trac\\xE9 1126",
    d: "M1399.842,236.669v-3.155h8.179v3.155",
    transform: "translate(-1399.842 -216.802)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduitIconBlack);
export default __webpack_public_path__ + "static/media/produit-icon-black.6e7ed6a5b7f6846fc3e9518c4fb409ef.svg";
export { ForwardRef as ReactComponent };